const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const STORE_KEY = "cs_first_touch_utm";
const FALLBACK_UTM = {
  utm_source: "consultantsucces.ca",
  utm_medium: "website",
  utm_campaign: "cs-wc-qc-2026",
};

export const APPLY_URL = process.env.REACT_APP_APPLY_URL || "";
export const PORTAL_URL = process.env.REACT_APP_MERCHANT_PORTAL_URL || "";

export const isApplyEnabled = () => Boolean(APPLY_URL);

const readUrlUtm = () => {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) found[k] = v;
  });
  return found;
};

export const captureUtm = () => {
  try {
    const found = readUrlUtm();
    if (Object.keys(found).length && !sessionStorage.getItem(STORE_KEY)) {
      sessionStorage.setItem(STORE_KEY, JSON.stringify(found));
    }
  } catch (e) { /* storage unavailable */ }
};

export const getApplyUrl = () => {
  if (!APPLY_URL) return "";
  let utm = {};
  try {
    utm = JSON.parse(sessionStorage.getItem(STORE_KEY) || "{}");
    if (!Object.keys(utm).length) utm = readUrlUtm();
  } catch (e) {
    utm = readUrlUtm();
  }
  if (!Object.keys(utm).length) utm = FALLBACK_UTM;
  const url = new URL(APPLY_URL);
  Object.entries(utm).forEach(([k, v]) => url.searchParams.set(k, v));
  return url.toString();
};
